import routesLimited from '@/constants/routesLimited'
import type { RouteRecordRaw } from 'vue-router'

export const documenttypeExport: RouteRecordRaw = {
	component: () =>
		import('components/templates/Datatable/Selected/DocumenttypeExport.vue'),
	meta: {
		title: 'Export Document Types',
		auth: true,
		limited: routesLimited.can_update,
	},
	name: 'documenttypeExport',
	path: '/documenttypes/export',
	props: true,
}

export const documenttypeCutoff: RouteRecordRaw = {
	component: () =>
		import('components/templates/Datatable/Selected/DocumenttypeCutoff.vue'),
	meta: {
		title: 'Document Type Cutoff',
		auth: true,
		limited: routesLimited.can_update,
	},
	name: 'documenttypeCutoff',
	path: '/documenttypes/cutoff',
	props: true,
}

export const documenttypeBulkEdit: RouteRecordRaw = {
	component: () =>
		import(
			'components/templates/Datatable/Selected/DocumenttypeBulkEdit.vue'
		),
	meta: {
		title: 'Bulk Edit Document Types',
		auth: true,
		limited: routesLimited.can_update,
	},
	name: 'documenttypeBulkEdit',
	path: '/documenttypes/bulk-edit',
	props: true,
}
